import React, { useCallback, useEffect, useRef, useState } from "react";
// import { useStaticQuery, graphql, Link } from "gatsby";

import searchClosepop from "../../../common/images/Global/header/search-closepop.png";
import Eclipse from "../../../common/images/Global/Eclipse.gif";
import SiteTrans from "../../LangConfig/siteTrans.json";


// import $ from 'jquery';

const Search = (props) => {
  let searchiconurl =
    "https://media.jameelmotors.com/wp-content/uploads/2023/12/search.svg";
  // let loadingiconurl =
  //   "https://media.aljhealth.com/wp-content/uploads/2022/07/15121616/blue-spin.gif";
  // const urlSegments = window.location.pathname.split('/');
  // const segmentLanguage = urlSegments[1];

  const [skeyword, SetSkeyword] = useState("");
  const [searchResult, SetSearchResult] = useState("");
  const [searchResultLoop, SetSearchResultLoop] = useState("");
  const [searchPageIcon, SetSearchPageIcon] = useState(searchiconurl);
  const [partnersResult, SetPartnersResult] = useState("");
  const [pageResult, SetPageResult] = useState("");
  const [intheNewsResult, SetIntheNewsResult] = useState("");
  const [solutionsResult, SetSolutionsResult] = useState("");
  const [peoplesResult, SetPeoplesResult] = useState("");
  const [newsResult, SetNewsResult] = useState("");
  const [insightsResult, SetInsightsResult] = useState("");
  const [quickreadsResult, SetQuickreadsResult] = useState("");
  const [isActive, setIsActive] = useState(false);
  const searchModalRef = useRef();
  const [showOverlay, setShowOverlay] = useState(false);
 

  useEffect(() => {
    searchModalRef.current.addEventListener("hide.bs.modal", (event) => {
      // console.log('hide')
      setShowOverlay(false);
    });
    searchModalRef.current.addEventListener("show.bs.modal", (event) => {
      // console.log('show')
      setShowOverlay(true);
    });
  });

  console.log(props.lang,"props.langprops.langprops.lang")

  let transString =
  props.lang === "en_US" ? "en_US" : props.lang === "ar" ? "ar" : props.lang === "zh_CN" ? "zh_CN" : props.lang === "tr_TR" ? "tr_TR" : "en_US";
  
  console.log(transString,"transString")

  const siteSearch = () => {
    if (skeyword !== null && skeyword !== "") {
      let searchlang =
      props.lang === "en_US" ? "en" : props.lang === "ar" ? "ar" : props.lang === "zh_CN" ? "zh-hans" : props.lang === "tr_TR" ? "tr" : "en";

        console.log(searchlang,"searchlang searchlang searchlang")

      SetSearchPageIcon(Eclipse);
      var axios = require("axios");
      axios
        .get(
          "https://ogwc5w7lme.execute-api.eu-west-2.amazonaws.com/default/Jameel-Motors-Generic-API?keyword=" +
            skeyword +
            "&lang=" +
            searchlang +
            "&per_page=100"
        )
        .then(function (response) {
          if (response !== null && response !== "") {
            let filterlist = response.data.filter(
              (list) => list.subtype !== "journey" && list.subtype !== "brands"
            );
            //to show only selected posttype search result
            SetSearchResult(filterlist);
            SetSearchResultLoop(filterlist);
            

            // to show all posttype search results
            // SetSearchResult(response.data);
            // SetSearchResultLoop(response.data);
          }

          SetSearchPageIcon(searchiconurl);
        })
        .catch(function (error) {
          SetSearchPageIcon(searchiconurl);
          // //console.log(error);
        });
    } else {
      SetSearchResult(null);
      SetSearchResultLoop(null);
      SetPartnersResult("");
      SetPageResult("");
      SetSolutionsResult("");
      SetPartnersResult("");
      SetIntheNewsResult("");
      SetNewsResult("");
      SetInsightsResult("");
      SetPeoplesResult("");
      SetQuickreadsResult("");
    }
  };

  function filterSearch(type, active) {
    SetSearchResultLoop(type);
    setIsActive(active);
  }

  function debounce(fn, delay) {
    let timer;
    return function () {
      let context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(context, args);
      }, delay);
    };
  }

  const delaySaveToDb = useCallback(
    debounce((val) => {
    SetSkeyword(val);
    }, 400),
    []
  );

  useEffect(()=>{
      siteSearch();
  },[skeyword])

  const handleSearchChange = (event) => {
    delaySaveToDb(event.target.value)
  };

  useEffect(() => {
    if (searchResult !== null && searchResult !== "") {
      let partnerslist,
        solutionslist,
        poepleslist,
        newslist,
        insightslights,
        inthenewslist,
        quickreadlist,
        pagelist;

      // partnerslist = searchResult.filter((list) => list.subtype === "markets");
      // SetPartnersResult(partnerslist);

      pagelist = searchResult.filter((list) => list.subtype === "page");
      SetPageResult(pagelist);

      solutionslist = searchResult.filter(
        (list) => list.subtype === "businesssolution"
      );
      SetSolutionsResult(solutionslist);

      inthenewslist = searchResult.filter((list) => list.subtype === "post");
      SetIntheNewsResult(inthenewslist);

      newslist = searchResult.filter((list) => list.subtype === "news");
      SetNewsResult(newslist);

      insightslights = searchResult.filter(
        (list) => list.subtype === "insights"
      );
      SetInsightsResult(insightslights);

      quickreadlist = searchResult.filter(
        (list) => list.subtype === "quickreads"
      );
      SetInsightsResult(quickreadlist);

      poepleslist = searchResult.filter((list) => list.subtype === "ourpeople");
      SetPeoplesResult(poepleslist);
    }
  }, [searchResult]);

  return (
    <header className={props.cls}>
      {showOverlay && (
        <div
          className="mobile-overlay"
          data-bs-dismiss="modal"
          data-bs-target="#searchmodal"
        ></div>
      )}
      <div className="search-model-container">
        <div
          className="modal jameel-motors-modal fade"
          id="searchmodal"
          ref={searchModalRef}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex search-clone-container">
                  <button
                    type="button"
                    className="close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <img src={searchClosepop} alt="Jameel Motors" />
                  </button>
                </div>
                <div className="container">
                  <div className="search-wrapper">
                    <h4>{SiteTrans.what_are_you_looking_for[transString]}</h4>
                    <div className="styled-search-root-sc-17d2bsu-0 fxTRBf">
                      <form
                        className="styled-search-box-sc-fds6jn-0 buxDGr"
                        action="#"
                      >
                        <input
                          className="SearchInput font-lg form-control"
                          type="text"
                          placeholder={SiteTrans.enter_your_search_here[transString]}
                          aria-label="Search"
                          onChange={handleSearchChange}
                          // onKeyUp={siteSearch}
                          onKeyPress={(ev) => {
                            if (ev.key === "Enter") {
                              ev.preventDefault();
                              siteSearch();
                            }
                          }}
                        />
                        {searchPageIcon ? (
                          <button
                            className="SearchPageIcon"
                            onClick={siteSearch}
                          >
                            <img
                              // className="SearchPageIcon"
                              src={searchPageIcon}
                              alt="img"
                            />
                          </button>
                        ) : null}
                      </form>
                    </div>
                  </div>

                  <div className="search-scroll">
                    <div className="row">
                      <div className="col-md-12">
                        <div className="search-pagination">
                          <ul>
                            {pageResult !== "" && pageResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "pageResult" ? "active" : ""
                                  }
                                  onClick={() =>
                                    filterSearch(pageResult, "pageResult")
                                  }
                                >
                                  {SiteTrans.page_txt[transString]} ({pageResult.length})
                                </a>
                              </li>
                            ) : null}
                            {solutionsResult !== "" &&
                            solutionsResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "solutionsResult"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    filterSearch(
                                      solutionsResult,
                                      "solutionsResult"
                                    )
                                  }
                                >
                                  Solutions ({solutionsResult.length})
                                </a>
                              </li>
                            ) : null}
                            {partnersResult !== "" &&
                            partnersResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "partnersResult"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    filterSearch(
                                      partnersResult,
                                      "partnersResult"
                                    )
                                  }
                                >
                                  Our Market ({partnersResult.length})
                                </a>
                              </li>
                            ) : null}

                            {peoplesResult !== "" &&
                            peoplesResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "peoplesResult" ? "active" : ""
                                  }
                                  onClick={() =>
                                    filterSearch(peoplesResult, "peoplesResult")
                                  }
                                >
                                  {" "}
                                  {SiteTrans.our_people_txt[transString]} ({peoplesResult.length})
                                </a>
                              </li>
                            ) : null}

                            {newsResult !== "" && newsResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "newsResult" ? "active" : ""
                                  }
                                  onClick={() =>
                                    filterSearch(newsResult, "newsResult")
                                  }
                                >
                                  {SiteTrans.news_txt[transString]} ({newsResult.length})
                                </a>
                              </li>
                            ) : null}

                            {intheNewsResult !== "" &&
                            intheNewsResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "intheNewsResult"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    filterSearch(
                                      intheNewsResult,
                                      "intheNewsResult"
                                    )
                                  }
                                >
                                  {SiteTrans.in_the_news_txt[transString]} ({intheNewsResult.length})
                                </a>
                              </li>
                            ) : null}

                            {insightsResult !== "" &&
                            insightsResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "insightsResult"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    filterSearch(
                                      insightsResult,
                                      "insightsResult"
                                    )
                                  }
                                >
                                  {SiteTrans.insights_txt[transString]} ({insightsResult.length})
                                </a>
                              </li>
                            ) : null}

                            {quickreadsResult !== "" &&
                            quickreadsResult.length > 0 ? (
                              <li>
                                <a
                                  href="#/"
                                  className={
                                    isActive === "quickreadsResult"
                                      ? "active"
                                      : ""
                                  }
                                  onClick={() =>
                                    filterSearch(
                                      quickreadsResult,
                                      "quickreadsResult"
                                    )
                                  }
                                >
                                  {SiteTrans.quick_reads_txt[transString]} ({quickreadsResult.length})
                                </a>
                              </li>
                            ) : null}

                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`search-result ${
                        props.lang === "ar" ? "search-result-ar" : ""
                      }`}
                    >
                      <div className="row mt-3">
                        <div className="col-md-12 mb-4 text-right">
                          {searchResultLoop !== null &&
                          searchResultLoop !== "" ? (
                            <>{searchResultLoop.length} {SiteTrans.results_txt[transString]}</>
                          ) : null}
                        </div>
                        {searchResultLoop !== null && searchResultLoop !== ""
                          ? searchResultLoop.map((result, index) => (
                              <div
                                key={index}
                                className="col-md-6 mb-4 search-results-text"
                                data-bs-dismiss="modal"

                              >
                                
                                {/* {console.log(result.url.replace(/^.*\/\/[^#]+/, ""),'url')} */}
                                <a
                                  // href={result.url.replace(/^.*\/\/[^#]+/, "")}
                                  href={result.url.replace(
                                    "https://editor.jameelmotors.com",
                                    `${window.location.origin}`
                                  )}
                                 
                                  rel="noreferrer"
                                  aria-label="search"
                                >
                                  <span
                                    dangerouslySetInnerHTML={{
                                      __html: result.title,
                                    }}
                                  ></span>
                                </a>
                              </div>
                            ))
                          : null} 
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Search;
